// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-store-screen {
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 768px) {
  .theme-store-screen {
    margin-top: 1.5rem;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/layouts/store/index.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;AAAJ;AAEI;EALF;IAMI,kBAAA;IACA,sBAAA;EACJ;AACF","sourcesContent":[".theme-store {\n  &-screen {\n    margin-top: 2rem;\n    display: flex;\n    justify-content: space-between;\n\n    @media (max-width: 768px) {\n      margin-top: 1.5rem;\n      flex-direction: column;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
